import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Assessment, Languages, Norms, Package, Participant, Project } from './models';
import { map, Observable, switchMap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiCreateService {
  private http = inject(HttpClient);
  private base = environment.apiBaseUrl;
  private reportBase = environment.reportBaseUrl + '/api';

  static DEFAULT_HEADERS: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  createProject(name: string): Observable<Project> {
    console.log('calling create project...');
    return this.http
      .post(`${this.base}/api/projects/`, `"${name}"`, {
        headers: ApiCreateService.DEFAULT_HEADERS,
        observe: 'response',
      })
      .pipe(
        switchMap((response) => {
          if (response.status !== 201) {
            throw new Error('Unexpected status code returned from create response');
          }

          const locationHeader = response.headers.get('Location');
          if (!locationHeader) {
            throw new Error('Location header not found in create response');
          }
          // GET the created project using the Location header
          return this.http.get<Project>(`${this.base}${locationHeader}`);
        }),
      );
  }

  putProject(project: Project): Observable<Project> {
    console.log('calling put project...');
    return this.http
      .put(`${this.base}/api/projects/${project.id}`, project, {
        headers: ApiCreateService.DEFAULT_HEADERS,
      })
      .pipe(map(() => project));
  }
}
